import { Box, styled } from '@mui/material';

export const SongActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));

export const StudioButtonBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& :hover': {
    color: theme.palette.grey[100],
    borderColor: theme.palette.grey[100],
  },
}));

export const DesktopSongActionButtonsContainer = styled(Box)(({ theme }) => ({
  [`@container (max-width: ${theme.breakpoints.values.sm}px)`]: {
    display: 'none',
  },
}));

export const MobileSongActionButtonsContainer = styled(Box)(({ theme }) => ({
  [`@container (min-width: ${theme.breakpoints.values.sm}px)`]: {
    display: 'none',
  },
}));
